import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../../components/global/layout';
import './style.scss';
import { Link } from 'react-router-dom';
import { Tooltip } from "antd";
import { FiEdit3, FiPlus } from 'react-icons/fi';
import { FaTrashAlt } from 'react-icons/fa';
import Table from "../../components/Table";
import SelectDropdown from '../../components/common/SelectDropdown';
import statusModel from '../../models/status.model';
import datepipeModel from '../../models/datepipemodel';
import shared from "./shared";
import ApiClient from '../../methods/api/apiClient';
import { useSelector } from 'react-redux';
import { IoEyeOutline } from 'react-icons/io5';
import { IoIosMail } from "react-icons/io";
import { LiaHistorySolid } from 'react-icons/lia';
import environment from '../../environment';
import timezoneModel from '../../models/timezone.model';

const Html = ({
    sorting,
    filter,
    edit,
    view,
    statusChange,
    pageChange,
    count,
    deleteItem,
    clear,
    filters,
    setFilter,
    loaging,
    data,historyPage,
    changestatus,
    isAllow,sendMail,
    total = { total }
}) => {
    const user = useSelector((state) => state.user);
    const meetingStatus =[
        { id: 'completed', name: 'Closed' },
        { id: 'open', name: 'Open' },
    ]
    const getUserRoleInGroup = (groupId) => {
        const gid = groupId?._id || groupId;
        const group = user?.groups?.find(g => {
            const ugid = g.groupId?._id || g.groupId;
            return ugid === gid && g.status === 'active';
        });
        if (!group) return null;
        const roleId = group.customerRole?._id || group.customerRole;
        return roleId;
    };

    const isGLInEventGroup = (itm) => {
        const roleId = getUserRoleInGroup(itm.groupId);
        return roleId && environment.groupLeaderRoleIds.includes(roleId);
    };
    // cw: CMMs should not see edit/delete buttons
    const isCMMInEventGroup = (itm) => {
        const roleId = getUserRoleInGroup(itm.groupId);
        return roleId === environment.connectmeetmanagerRoleId;
    };

    const [hoveredSeries, setHoveredSeries] = useState(null);
    const [seriesFilter, setSeriesFilter] = useState('');
    const hoverTimeout = React.useRef(null);

    const groupedData = useMemo(() => {
        if (!data || !data.length) return [];
        const seriesMap = {};
        const standalone = [];
        data.forEach(evt => {
            if (evt.seriesId) {
                if (!seriesMap[evt.seriesId]) seriesMap[evt.seriesId] = [];
                seriesMap[evt.seriesId].push(evt);
            } else {
                standalone.push(evt);
            }
        });
        const result = [...standalone];
        Object.values(seriesMap).forEach(events => {
            const sorted = [...events].sort((a, b) => new Date(a.date) - new Date(b.date));
            const representative = { ...sorted[0], _seriesEvents: sorted, _seriesCount: sorted.length };
            result.push(representative);
        });
        result.sort((a, b) => new Date(b.date) - new Date(a.date));
        return result;
    }, [data]);

    const handleSeriesEnter = (seriesId) => {
        if (hoverTimeout.current) clearTimeout(hoverTimeout.current);
        setHoveredSeries(seriesId);
    };
    const handleSeriesLeave = () => {
        hoverTimeout.current = setTimeout(() => { setHoveredSeries(null); setSeriesFilter(''); }, 200);
    };

    const columns = [
        {
            key: 'title', name: 'Title', sort: true,
            render: (row) => {
                if (row._seriesCount > 1) {
                    const userTz = user?.timezone || row.timezone;
                    const isOpen = hoveredSeries === row.seriesId;
                    const filtered = isOpen ? row._seriesEvents.filter(evt => {
                        if (!seriesFilter) return true;
                        const d = new Date(evt.date);
                        const label = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
                        return label.includes(seriesFilter);
                    }).filter((evt, i, arr) => {
                        const dateStr = new Date(evt.date).toISOString().slice(0, 16);
                        return arr.findIndex(e => new Date(e.date).toISOString().slice(0, 16) === dateStr) === i;
                    }) : [];
                    return (
                        <div className="relative" onMouseEnter={() => handleSeriesEnter(row.seriesId)} onMouseLeave={handleSeriesLeave}>
                            <span className='firstc cursor-pointer text-primary hover:underline' onClick={() => view(row?.id || row?._id)}>
                                {row?.title}
                            </span>
                            <span className="absolute -top-4 -right-6 inline-flex items-center justify-center px-1.5 py-0.5 text-xs font-semibold text-white bg-orange-500 rounded-full">
                                x{row._seriesCount}
                            </span>
                            {isOpen && (
                                <div className="absolute left-0 top-full z-50 pt-1" onMouseEnter={() => handleSeriesEnter(row.seriesId)} onMouseLeave={handleSeriesLeave}>
                                    <div className="bg-white border border-gray-200 rounded-lg shadow-lg py-2 min-w-[280px]">
                                        <p className="px-3 pb-1 text-xs font-semibold text-gray-500 border-b border-gray-100 mb-1">Recurring Series ({row._seriesCount} events)</p>
                                        {row._seriesCount > 6 && (
                                            <div className="px-3 py-1.5">
                                                <input
                                                    type="text"
                                                    placeholder="Filter by YYYY-MM..."
                                                    value={seriesFilter}
                                                    onChange={(e) => setSeriesFilter(e.target.value)}
                                                    onClick={(e) => e.stopPropagation()}
                                                    className="w-full text-sm border border-gray-300 rounded px-2 py-1 focus:outline-none focus:border-orange-400"
                                                />
                                            </div>
                                        )}
                                        <div className="max-h-[240px] overflow-y-auto">
                                            {filtered.length > 0 ? filtered.map(evt => (
                                                <div
                                                    key={evt.id || evt._id}
                                                    className="px-3 py-1.5 hover:bg-orange-50 cursor-pointer text-sm text-gray-700 flex items-center gap-2"
                                                    onClick={(e) => { e.stopPropagation(); view(evt.id || evt._id); }}
                                                >
                                                    <span className="text-orange-500">📅</span>
                                                    {datepipeModel.formatDateToTimezone(evt.date, userTz)}
                                                </div>
                                            )) : (
                                                <p className="px-3 py-2 text-xs text-gray-400">No events match</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                }
                return <span className='firstc cursor-pointer text-primary hover:underline' onClick={() => view(row?.id || row?._id)}>{row?.title}</span>
            }
        },
        {
            key: 'date', name: 'Event Date',
            render: (row) => {
                const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const userProfileTimezone = user?.timezone || browserTimezone;
                const eventTimezone = row.timezone;
                const isTimezoneConflict = eventTimezone && eventTimezone !== userProfileTimezone;

                const tzOption = timezoneModel.list.find(tz => tz.id === eventTimezone);
                const displayName = tzOption?.name || eventTimezone;

                if (row._seriesCount > 1) {
                    const first = row._seriesEvents[0];
                    const last = row._seriesEvents[row._seriesEvents.length - 1];
                    return <>
                        <span className="text-xs text-gray-500">
                            {datepipeModel.formatDateToTimezone(first.date, userProfileTimezone)} – {datepipeModel.formatDateToTimezone(last.date, userProfileTimezone)}
                        </span>
                        {isTimezoneConflict && (
                            <span className="text-red-500 text-xs ml-2" title={`Browser: ${browserTimezone}, Showing: ${displayName}`}>
                                ⚠️ {displayName}
                            </span>
                        )}
                    </>
                }

                return <>
                    {datepipeModel.formatDateToTimezone(row.date, userProfileTimezone)}
                    {isTimezoneConflict && (
                        <span className="text-red-500 text-xs ml-2"
                              title={`Browser: ${browserTimezone}, Showing: ${displayName}`}>
                            ⚠️ {displayName}
                        </span>
                    )}
                </>
            }
        },
        {
            key: 'groupId', name: 'Group',
            render: (row) => {
                return <> <p className='capitalize'>{row?.groupDetails?.name}</p></>
            }
        },
        {
            key: 'timezone', name: 'Timezone',
            render: (row) => {
                return <>{row?.timezone}</>
            }
        },
        {
            key: 'Meeting status', name: 'Meeting Status',
            render: (row) => {
                return <>
                    <div className='w-32' >
                        {/* <Tooltip placement="top" title="Active / Inactive"> */}
                            <span className='bg-[#EEE] text-sm !px-3 h-[30px] flex items-center justify-center border border-[#EBEBEB] text-[#3C3E49A3] !rounded capitalize'>
                                {row.meetingStatus === "completed" ? "Closed" : "Open"}
                            </span>
                        {/* </Tooltip> */}
                    </div>
                </>
            }
        },
        {
            key: 'action', name: 'Action',
            render: (itm) => {
                const meetingStart = () => {
                    let value = false
                    if (data && new Date(datepipeModel.datetime(itm?.date)).getTime() >= new Date().getTime()) value = true
                    return value
                  }
                return <>
                    <div className="flex items-center justify-start gap-1.5">
                        <Tooltip placement="top" title="View">
                            <a className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-9 h-9 text-neutral-800 flex items-center justify-center text-md " onClick={e => view(itm.id)}>
                            <IoEyeOutline />
                            </a>
                        </Tooltip>
                        {isAllow(`edit${shared.check}`) && itm.addedBy == user._id && itm.meetingStatus === "completed"?
                            <Tooltip placement="top" title="History">
                                <a className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-9 h-9 text-neutral-800 flex items-center justify-center text-md " onClick={e => historyPage(itm.id)}>
                                    <LiaHistorySolid />
                                </a>
                            </Tooltip>
                            : <></>}
                        {(itm.addedBy == user._id || isGLInEventGroup(itm)) && !isCMMInEventGroup(itm) ?
                            <Tooltip placement="top" title="Edit">
                                <a className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-9 h-9 text-neutral-800 flex items-center justify-center text-md " onClick={e => edit(itm.id)}>
                                    <FiEdit3 />
                                </a>
                            </Tooltip>
                            : <></>}
                        {(itm.addedBy == user._id || isGLInEventGroup(itm)) && !isCMMInEventGroup(itm) ? <Tooltip placement="top" title="Delete"> <span className='border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-9 h-9 text-neutral-800 flex items-center justify-center text-md ' onClick={() => deleteItem(itm.id)}>
                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>
                        </span> </Tooltip> : <></>}
                        {isAllow(`delete${shared.check}`) && meetingStart() && (itm.addedBy == user._id || isGLInEventGroup(itm)) && itm?.meetingStatus !== "completed" ? <Tooltip placement="top" title="Send Reminder Email"> <span className='border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-9 h-9 text-neutral-800 flex items-center justify-center text-md ' onClick={() => sendMail(itm.id)}>
                        <IoIosMail />
                        </span> </Tooltip> : <></>}
                    </div>
                </>
            }
        },
    ]

    const [groups, setGroup] = useState([])

    const getGroups = () => {
        let f = {
            page: 1,
            count: 10
        }
        ApiClient.get('api/group/list', f).then(res => {
            if (res.success) {
                setGroup(res.data)
            }
        })
    }

    useEffect(() => {
        getGroups()
    }, [])


    return (
        <Layout>
            <div className="flex flex-wrap justify-between items-center gap-y-4">
                <div>
                    <h3 className="text-2xl font-semibold text-[#111827]"> {shared.title}s</h3>
                    <p class="text-sm font-normal text-[#75757A]">Here you can see all about your {shared.title}s</p>
                </div>

                <a id='downloadFile'></a>

                <div className="flex">


                    {/* <button className="!px-2.5 text-[#3C3E49] text-sm font-normal py-2.5 flex items-center justify-center gap-2 bg-[#fff] rounded-lg shadow-btn hover:bg-[#F3F2F5] border border-[#D0D5DD] transition-all focus:ring-2 ring-[#F1F2F3] disabled:bg-[#F3F2F5] disabled:cursor-not-allowed mr-3" onClick={() => exportfun()}>
                        <PiFileCsv className="text-typo text-xl" />  Export CSV
                    </button> */}

                    {isAllow(`add${shared.check}`) ?
                        <Link className="bg-primary leading-10 mr-3 h-10 flex items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg gap-2" to={`/${shared.url}/add`}>
                            +   Add {shared.title}
                        </Link>
                        : <></>}
                </div>


            </div>



            <div className='shadow-box w-full bg-white rounded-lg mt-6'>
                <div className='flex p-4 items-center flex-wrap'>

                    <form class="flex items-center max-w-sm" onSubmit={e => {
                        e.preventDefault()
                        filter()
                    }}>
                        <label for="simple-search" className="sr-only">Search</label>
                        <div className="relative w-full">
                            {/* <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                                <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 20">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5v10M3 5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 0V6a3 3 0 0 0-3-3H9m1.5-2-2 2 2 2"/>
                                </svg>
                            </div> */}
                            <input type="text" id="simple-search"
                                value={filters.search}
                                onChange={e => {
                                    setFilter({ ...filters, search: e.target.value })
                                }}
                                className="bg-gray-50 pr-10 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-orange-500 focus:border-orange-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-orange-500 dark:focus:border-orange-500" placeholder="Search" required 
                            
                                />
                                {filters?.search && (
                        <i
                          className="fa fa-times absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 text-sm"
                          aria-hidden="true"
                          onClick={(e) => clear()}
                        ></i>
                      )}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
                        </div>
                        <button type="submit" className="p-2.5 m-2 text-sm font-medium text-white bg-blue-700 rounded-lg border border-orange-500  focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                            <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                            </svg>
                            <span className="sr-only">Search</span>
                        </button>
                    </form>
                                                        
                    <div className="flex gap-2 ml-auto">
                        <SelectDropdown
                            id="statusDropdown"
                            displayValue="name"
                            placeholder=" Meeting Status"
                            intialValue={filters.meetingStatus}
                            result={e => { changestatus(e.value) }}
                            options={meetingStatus}
                        />
                        {/* <SelectDropdown
                            id="statusDropdown"
                            displayValue="name"
                            placeholder='All Groups'
                            intialValue={filters.groupId}
                            theme="search"
                            result={e => filter({ groupId: e.value })}
                            options={groups}
                        /> */}
                        {filters.meetingStatus || filters.groupId || filters.search ? <>
                            <button
                                className="bg-primary leading-10 h-10 inline-block shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg"
                                onClick={() => clear()}>
                                Reset
                            </button>
                        </> : <></>}


                    </div>
                </div>



                {!loaging ? <>
                    <Table
                        className='mb-3'
                        data={groupedData}
                        columns={columns}
                        page={filters.page}
                        count={filters.count}
                        total={total}
                         nodata="No events yet"
                        result={(e) => {
                            if (e.event == 'page') pageChange(e.value)
                            if (e.event == 'sort') sorting(e.value)
                            if(e.event == 'count') count(e.value)
                        }}
                    />

                </> : <></>}

                {
                    loaging ? <div className="text-center py-4">
                        <img src="/assets/img/loader.gif" className="pageLoader" />
                    </div> : <></>
                }

            </div>
        </Layout >
    );
};

export default Html;
